import React from "react";

const KNOWN_MAPPING = {
  "147d90e1-807c-4f89-8888-1c1ef95c610a-1-201-a_3.jpeg": "image00005.jpeg",
  "5185b00d-53e5-4850-9686-7ae2c637a41c-1-105-c_1.jpeg": "image00025.jpeg",
  "6156200c-093b-4be1-8eec-7f535cf4584a-1-105-c_4.jpeg": "image00028.jpeg",
  "3f8042c3-3a14-4e76-a384-37bd9b321589_2.jpg": "image00012.jpeg",
  "93502ed9-37fc-45cc-98b6-c1bde7ae83ac-1-105-c_3.jpeg": "image00035.jpeg",
  "5185b00d-53e5-4850-9686-7ae2c637a41c-1-105-c.jpeg": "image00025.jpeg",
  "hero-byggeri.jpg": "image00030.jpeg",
  "9ea201d7-b0a1-4ad5-a1a3-64a5b552d0c0-1-105-c.jpeg": "image00018.jpeg",
  "15b7304c-8d2c-48e3-b4cf-33243ca54f34-1-105-c_1.jpeg": "image00013.jpeg",
  "8b6a9d5b-7ade-4290-af1c-1b88b0fa9dae-1-105-c.jpeg": "image00029.jpeg",
  "10f77508-4e7f-45d8-b781-ae0541f5834c-1-105-c_2.jpeg": "image00026.jpeg",
  "1890e9d0-63dc-4d4d-938f-cb74decd5f83-1-105-c.jpeg": "image00001.jpeg",
  "15b7304c-8d2c-48e3-b4cf-33243ca54f34-1-105-c.jpeg": "image00013.jpeg",
  "147d90e1-807c-4f89-8888-1c1ef95c610a-1-201-a.jpeg": "image00005.jpeg",
  "6156200c-093b-4be1-8eec-7f535cf4584a-1-105-c.jpeg": "image00028.jpeg",
  "3f8042c3-3a14-4e76-a384-37bd9b321589.jpg": "image00012.jpeg",
  "93502ed9-37fc-45cc-98b6-c1bde7ae83ac-1-105-c.jpeg": "image00035.jpeg",
  "7b72f5a1-49a0-4cf8-a051-2cf9ab518b22-1-105-c.jpeg": "image00021.jpeg",
  "13804d69-1cb7-4b96-9854-41a9fea65893-1-105-c_1.jpeg": "image00023.jpeg",
  "7632524f-1115-485f-bb70-85940e89adec-1-105-c_2.jpeg": "image00033.jpeg",
  "60be0096-2504-400c-bbd6-e0d67c0d8ea4-1-105-c_3.jpeg": "image00007.jpeg",
  "478bd9f7-3e35-4c2a-9cf3-690eadb90c86-1-105-c.jpeg": "image00022.jpeg"
};

export default function TestImages() {
  return (
    <div className="p-8 max-w-7xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">Billedkortlægning</h1>
      <div className="bg-neutral-100 p-4 rounded-lg mb-8">
        <h2 className="text-lg font-bold mb-2">JSON Mapping Output:</h2>
        <pre id="json-output" className="text-xs bg-white p-4 rounded border overflow-x-auto">
          {JSON.stringify(KNOWN_MAPPING, null, 2)}
        </pre>
      </div>
    </div>
  );
}
